import { render, staticRenderFns } from "./BAlert.vue?vue&type=template&id=6eec565e&scoped=true"
import script from "./BAlert.vue?vue&type=script&lang=js"
export * from "./BAlert.vue?vue&type=script&lang=js"
import style0 from "./BAlert.vue?vue&type=style&index=0&id=6eec565e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eec565e",
  null
  
)

export default component.exports